/**
 * Video App Promo Modal (R2) Mixpanel event constants.
 * These are client-side only — fired by the <vm-video-app-promo-modal> Lit component.
 */

export const VideoAppPromoModalEvents = {
    INTERSTITIAL_OPENED: 'InterstitialOpened',
    CTA_CLICKED: 'VideoAppPromoModalCTAClicked',
    DISMISSED: 'VideoAppPromoModalDismissed',
} as const;

export type VideoAppPromoModalEventName = (typeof VideoAppPromoModalEvents)[keyof typeof VideoAppPromoModalEvents];
